import graphql__2cc8fd67e1a1f7791492 from "./__generated__/CreateTermsAndConditionsDocumentDialogMutation.graphql.ts";import * as React from "react";
import {useIntl} from "react-intl";
import {commitMutation, graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateTermsAndConditionsDocumentDialogMutation} from "./__generated__/CreateTermsAndConditionsDocumentDialogMutation.graphql";
import {useRelayEnvironment} from "react-relay/hooks";
import Checkbox from "../form/Checkbox";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";

type Props = {
    handleCloseDialog: () => {}
}

const CreateTermsAndConditionsDocumentDialog: React.FC<Props> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateTermsAndConditionsDocumentDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__2cc8fd67e1a1f7791492,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateTermsAndConditionsDocument'})
            }
        )
    }
    const validationSchema = yup.object().shape({
        title: yup.string()
            .min(2, intl.formatMessage({id: 'validation.field.titleTooShort'}))
            .max(255, intl.formatMessage({id: 'validation.field.titleTooLong'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        code: yup.string()
            .matches(/^[a-z0-9-]{2,255}$/, intl.formatMessage({id: 'validation.field.invalidCode'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        version: yup.string()
            .matches(/^[a-zA-Z0-9,+~. -]{2,20}$/, intl.formatMessage({id: 'validation.field.invalidVersion'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        uri: yup.string()
            .matches(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/, intl.formatMessage({id: 'validation.field.invalidUri'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        startDate: yup.string()
            .matches(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/, intl.formatMessage({id: 'validation.field.invalidDate'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        publishDate: yup.string()
            .matches(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/, intl.formatMessage({id: 'validation.field.invalidDate'})),
        published: yup.bool()
    });

    const initialValues = {
        published: false
    }

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.CreateTermsAndConditionsDocumentDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.code'})}</Label>
                    <Field name="code" type="text" placeholder="tos-general" autoFocus={true}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.title'})}</Label>
                    <Field name="title" type="text" placeholder={intl.formatMessage({id: 'termsAndConditions.title.placeholder'})}/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.version'})}</Label>
                    <Field name="version" type="text" placeholder="v1.2.3"/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.uri'})}</Label>
                    <Field name="uri" type="text" placeholder="https://example.com"/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.startDate'})}</Label>
                    <Field name="startDate" type="text" placeholder="YYYY-MM-DD HH:MM:SS"/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.publishDate'})}</Label>
                    <Field name="publishDate" type="text" placeholder="YYYY-MM-DD HH:MM:SS"/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'termsAndConditions.published'})}</Label>
                    <Checkbox name="published"/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateTermsAndConditionsDocumentDialog;
